<!--
Loading

SHows a loading animation
-->

<template>
	<div class="c-loading">
		<p class="h-accessibility c-loading__text">Loading...</p>
		<svg class="c-loading__spinner" viewBox="0 0 50 50">
			<circle
				class="path"
				cx="25"
				cy="25"
				r="20"
				fill="none"
				stroke-width="10"
			></circle>
		</svg>
	</div>
</template>

<script>
	export default {
		name: "v-loading",
		data: function () {
			return {
				timeout: false,
				loadingTimeout: null,
			};
		},
		props: {
			dark: {
				default: false,
			},
			message: {
				default: true,
			},
		},
		mounted() {
			var self = this;

			if (this.message) {
				self.loadingTimeout = setTimeout(function () {
					self.timeout = true;
				}, 30000);
			}
		},
		beforeDestroy() {
			clearTimeout(this.loadingTimeout);
		},
	};
</script>
